import {useState, useLayoutEffect} from 'react';
import {createPortal} from 'react-dom';

interface iProps {
  children: JSX.Element;
  wrapperId: string;
}

export default function PortalModal(props: iProps) {
  const [portalElement, setPortalElement] = useState<HTMLElement | null>(null);

  useLayoutEffect(() => {
    let el = document.getElementById(props.wrapperId) as HTMLElement;
    let portalCreated = false;

    if (!el) {
      el = creeateWrapperAndAppendToBody(props.wrapperId);
      portalCreated = true;
    }

    setPortalElement(el);

    return () => {
      if (portalCreated && el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  }, [props.wrapperId]);

  const creeateWrapperAndAppendToBody = (elementId: string) => {
    const el = document.createElement("div");
    el.setAttribute("id", elementId);
    document.body.appendChild(el);
    return el;
  }

  if (!portalElement) return null;

  return createPortal(props.children, portalElement);
}
